import React, { useEffect, useState } from 'react';
import { Box, IconButton, Popover, TextField, Tooltip } from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import { ChromePicker } from 'react-color';
import { FormControl, Grid2, Stack, Typography } from '@mui/material';
import ShowContainer from './ShowContainer';
import CusTooltip from './CusTooltip';
import { useTranslation } from 'react-i18next';
import { IconX } from '@tabler/icons-react';

export default function CusColorPicker({
  label,
  value,
  onChange = () => {},
  fullWidth = true,
  width,
  isVerySmall,
  size = 'auto',
  tooltipText
}) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [color, setColor] = useState(value);

  useEffect(() => {
    if (!value) return;
    setColor(value);
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (newColor) => {
    setColor(newColor.hex);
    onChange(newColor.hex);
  };

  const open = Boolean(anchorEl);

  const onResetColor = (e) => {
    e.stopPropagation();
    onChange('');
    setColor('');
  };

  return (
    <>
      <Grid2 width={width} size={size}>
        <FormControl fullWidth sx={{ padding: '0' }}>
          <Stack display={'flex'} direction={'column'} gap={isVerySmall ? 0 : 0.5}>
            <ShowContainer condition={label}>
              <Stack
                display={'flex'}
                alignItems={'center'}
                flexDirection={'row'}
                gap={0.5}
                flexWrap={'wrap-reverse'}>
                <Typography color="textSecondary" fontSize={isVerySmall ? 12 : undefined}>
                  {t(label)}
                </Typography>
                {tooltipText && <CusTooltip text={tooltipText} />}
              </Stack>
            </ShowContainer>
            <TextField
              value={color}
              onClick={handleClick}
              onChange={(e) => {
                setColor(e.target.value);
                onChange(e.target.value);
              }}
              fullWidth={fullWidth}
              autoComplete="off"
              slotProps={{
                input: {
                  startAdornment: (
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: 1,
                        backgroundColor: color,
                        border: '1px solid #ccc',
                        mr: 1
                      }}
                    />
                  ),
                  endAdornment: (
                    <Stack gap={0.5} direction={'row'} alignItems={'center'}>
                      <ShowContainer condition={color}>
                        <Tooltip title={t('Clear')}>
                          <IconButton sx={{ padding: 0 }} onClick={onResetColor}>
                            <IconX size={16} />
                          </IconButton>
                        </Tooltip>
                      </ShowContainer>
                      <ColorLensIcon
                        sx={{ color: 'action.active', cursor: 'pointer' }}
                        onClick={handleClick}
                      />
                    </Stack>
                  )
                }
              }}
            />
          </Stack>
        </FormControl>
      </Grid2>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <ChromePicker color={color} onChange={handleChange} />
      </Popover>
    </>
  );
}
